import { render } from "./ServicesParametersModal.vue?vue&type=template&id=3494c556"
import script from "./ServicesParametersModal.vue?vue&type=script&lang=ts"
export * from "./ServicesParametersModal.vue?vue&type=script&lang=ts"

import "./ServicesParametersModal.vue?vue&type=style&index=0&id=3494c556&lang=scss"
script.render = render

export default script